import { createContext } from "react";

import * as amplitude from "@amplitude/analytics-browser";

type AmplitudeContextValue = typeof amplitude;

const AmplitudeContext = createContext<AmplitudeContextValue | null>(null);

export { AmplitudeContext };
